import { render } from "./App.vue?vue&type=template&id=51e9209e"
const script = {}

import "./App.vue?vue&type=style&index=0&id=51e9209e&lang=less"

import exportComponent from "D:\\wenlvVue\\yijiangshandao_v3\\yijiangshandao\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__